export const cilLevelDown = ["24 24","<path d='M17.47 16.345l-3.97 3.97v-15.814h-10.125v1.5h8.625v14.314l-3.97-3.97-1.061 1.061 5.78 5.78 5.78-5.78-1.061-1.061z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-level-down.js
// module id = null
// module chunks = 